// Recovered compiled webpack factory 21854. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      addSearchParamsToPageSegments: function () {
        return d;
      },
      handleAliasedPrefetchEntry: function () {
        return f;
      },
    }));
  let n = r(65360),
    a = r(17297),
    o = r(60895),
    i = r(29658),
    s = r(69190),
    l = r(60543),
    u = r(11126),
    c = r(35737);
  function f(e, t, r, f, p) {
    let h,
      _ = t.tree,
      m = t.cache,
      g = (0, i.createHrefFromUrl)(f),
      y = [];
    if ("string" == typeof r) return !1;
    for (let t of r) {
      if (
        !(function e(t) {
          if (!t) return !1;
          let r = t[2];
          if (t[3]) return !0;
          for (let t in r) if (e(r[t])) return !0;
          return !1;
        })(t.seedData)
      )
        continue;
      let r = t.tree;
      r = d(r, Object.fromEntries(f.searchParams));
      let { seedData: i, isRootRender: u, pathToSegment: p } = t,
        v = ["", ...p];
      r = d(r, Object.fromEntries(f.searchParams));
      let b = (0, o.applyRouterStatePatchToTree)(v, _, r, g),
        E = (0, a.createEmptyCacheNode)();
      if (u && i) {
        let t = i[1];
        ((E.loading = i[3]),
          (E.rsc = t),
          (function e(t, r, a, o, i) {
            if (0 !== Object.keys(o[1]).length)
              for (let l in o[1]) {
                let u,
                  c = o[1][l],
                  f = c[0],
                  d = (0, s.createRouterCacheKey)(f),
                  p = null !== i && void 0 !== i[2][l] ? i[2][l] : null;
                if (null !== p) {
                  let e = p[1],
                    r = p[3];
                  u = {
                    lazyData: null,
                    rsc: f.includes(n.PAGE_SEGMENT_KEY) ? null : e,
                    prefetchRsc: null,
                    head: null,
                    prefetchHead: null,
                    parallelRoutes: new Map(),
                    loading: r,
                    navigatedAt: t,
                  };
                } else
                  u = {
                    lazyData: null,
                    rsc: null,
                    prefetchRsc: null,
                    head: null,
                    prefetchHead: null,
                    parallelRoutes: new Map(),
                    loading: null,
                    navigatedAt: -1,
                  };
                let h = r.parallelRoutes.get(l);
                (h ? h.set(d, u) : r.parallelRoutes.set(l, new Map([[d, u]])), e(t, u, a, c, p));
              }
          })(e, E, m, r, i));
      } else
        ((E.rsc = m.rsc),
          (E.prefetchRsc = m.prefetchRsc),
          (E.loading = m.loading),
          (E.parallelRoutes = new Map(m.parallelRoutes)),
          (0, l.fillCacheWithNewSubTreeDataButOnlyLoading)(e, E, m, t));
      for (let e of (b && ((_ = b), (m = E), (h = !0)), (0, c.generateSegmentsFromPatch)(r))) {
        let r = [...t.pathToSegment, ...e];
        r[r.length - 1] !== n.DEFAULT_SEGMENT_KEY && y.push(r);
      }
    }
    return (
      !!h &&
      ((p.patchedTree = _),
      (p.cache = m),
      (p.canonicalUrl = g),
      (p.hashFragment = f.hash),
      (p.scrollableSegments = y),
      (0, u.handleMutable)(t, p))
    );
  }
  function d(e, t) {
    let [r, a, ...o] = e;
    if (r.includes(n.PAGE_SEGMENT_KEY)) return [(0, n.addSearchParamsIfPageSegment)(r, t), a, ...o];
    let i = {};
    for (let [e, r] of Object.entries(a)) i[e] = d(r, t);
    return [r, i, ...o];
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
